import { RegexMatch } from "@/data/enums/router";

export default [
  {
    path: "tickets",
    component: {
      name: "AdminClientTicketsWrapper",
      template: `<router-view v-bind="$attrs" />`
    },
    children: [
      {
        path: "",
        name: "adminClientSupportTickets",
        component: () =>
          import("@/views/admin/clients/client/tickets/index.vue"),
        meta: {
          title: "_.tickets",
          breadcrumb: {
            label: "_action.edit"
          }
        },
        props: {
          routes: require("./menu").ticketsTabigation
        }
      },
      {
        path: `:ticketId(${RegexMatch.UUID})`,
        name: "adminClientSupportTicket",
        component: () =>
          import("@/views/admin/clients/client/tickets/ticket/index.vue"),
        props: true
      }
    ]
  }
];
